import { render, staticRenderFns } from "./ItemSwipe.vue?vue&type=template&id=48e81689&scoped=true&"
import script from "./ItemSwipe.vue?vue&type=script&lang=js&"
export * from "./ItemSwipe.vue?vue&type=script&lang=js&"
import style0 from "./ItemSwipe.vue?vue&type=style&index=0&id=48e81689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e81689",
  null
  
)

export default component.exports